<svg
  width="25"
  height="26"
  viewBox="0 0 25 26"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
  <g clip-path="url(#clip0_86_787)">
    <path
      d="M10.0087 19.4032C9.02423 19.4032 8.53198 19.4032 8.16339 19.1345C7.79481 18.8658 7.6442 18.3972 7.34299 17.4599L5.78329 12.6065C5.48553 11.68 5.33666 11.2168 5.47579 10.7871C5.61492 10.3574 6.00708 10.0694 6.79141 9.49325L10.8424 6.5176C11.6415 5.93061 12.0411 5.63711 12.5 5.63711C12.9589 5.63711 13.3585 5.93061 14.1576 6.5176L18.2086 9.49325C18.9929 10.0694 19.3851 10.3574 19.5242 10.7871C19.6633 11.2168 19.5145 11.68 19.2167 12.6065L17.657 17.4599C17.3558 18.3972 17.2052 18.8658 16.8366 19.1345C16.468 19.4032 15.9758 19.4032 14.9913 19.4032H10.0087Z"
      fill="currentColor"
    />
  </g>
  <defs>
    <clipPath id="clip0_86_787">
      <rect width="25" height="25" fill="white" transform="translate(0 0.5)" />
    </clipPath>
  </defs>
</svg>
